import PaymentRequestsTableColumnNumber from './index.vue'
export default PaymentRequestsTableColumnNumber